import { Benefit } from "../data";

/**
 * The cost line shown on the card and in the detail sidebar, e.g.
 * "Included in membership, Varied".
 */
export const selectorBenefitCostLabel = (benefit: Benefit): string => {
  if (benefit.costShortDescription) {
    return benefit.costShortDescription;
  }

  const parts: string[] = [];

  if (!benefit.costIsNotIncluded) {
    parts.push("Included in membership");
  }

  if (benefit.costDescription) {
    parts.push(benefit.costDescription);
  }

  return parts.join(", ");
};
